export default "__VITE_ASSET__13f9e9ef__$_?nuxt_component=async&nuxt_component_name=SvgoMovieScreen__"